import React from "react";
import { compact } from "lodash";
import { Location } from "../Location";
import {
  CustomerContactPersonForm,
  InitialContactPersonData
} from "../../customers/CustomerContactPersonForm/CustomerContactPersonForm";

interface Params {
  contactPersonId: string;
  customerId: string;
  initialData: InitialContactPersonData;
}

export class ContactPersonLocation extends Location<Params> {
  constructor(
    customerId: string,
    contactPersonId?: string,
    initialData?: InitialContactPersonData
  ) {
    super({ customerId, contactPersonId, initialData });
  }

  render() {
    const { customerId, contactPersonId, initialData } = this.params;
    return (
      <CustomerContactPersonForm
        customerId={customerId}
        contactPersonId={contactPersonId}
        initialData={initialData}
      />
    );
  }

  toURI() {
    const { customerId, contactPersonId } = this.params;
    const parts = compact([
      "/customers",
      customerId,
      "contact-person",
      contactPersonId || "add"
    ]);
    return parts.join("/");
  }
}
